<template>
  <AdminProjects></AdminProjects>
</template>
  

<style src="./adminprojects.css" scoped></style>
<script src="./adminprojects.view.js"></script>

 